var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:("spinner-" + _vm.uuid),ref:"svgContainer",style:({ color: _vm.spinnerColor }),attrs:{"uk-spinner":_vm.formattedSpinnerRatio}})}
var staticRenderFns = []

export { render, staticRenderFns }